import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const CustomSwitchInput = ({
    label = "Block",
    activeLabel = "Active",
    isChecked = false,
    size = "",
    onClick = () => {},
    className = "", // Optional class from parent
    activeColorClass = "", // Optional override color class
    inactiveColorClass = "" // Optional override color class
}) => {
    return (
        <div onClick={onClick} className={className}>
            <div className={classNames("custom-switch", size, { active: isChecked })}>
                {isChecked ? (
                    <>
                        <span className="switch-label">{activeLabel}</span>
                        <div className={classNames("switch-circle", activeColorClass)}></div>
                    </>
                ) : (
                    <>
                        <div className={classNames("switch-circle", inactiveColorClass)}></div>
                        <span className="switch-label">{label}</span>
                    </>
                )}
            </div>
        </div>
    );
};

CustomSwitchInput.propTypes = {
    label: PropTypes.string,
    activeLabel: PropTypes.string,
    isChecked: PropTypes.bool,
    size: PropTypes.oneOf(["small", "large", ""]),
    onClick: PropTypes.func,
    className: PropTypes.string,
    activeColorClass: PropTypes.string,
    inactiveColorClass: PropTypes.string
};

export default CustomSwitchInput;
